import { withInstall } from "../utils";
import _SidebarItem from "./SidebarItem";
const SidebarItem = withInstall(_SidebarItem);
var stdin_default = SidebarItem;
export {
  SidebarItem,
  stdin_default as default
};
